<template>
  <div class="sidebar">
    <SidebarHeader/>
    <SidebarForm/>
    <nav class="sidebar-nav">
      <div slot="header"></div>

      <ul class="nav">
        <template v-for="(item, index) in filteredNavItems">

          <template v-if="item.title">
            <SidebarNavTitle :name="item.name" :classes="item.class" :wrapper="item.wrapper"/>
          </template>
          <template v-else-if="item.divider">
            <SidebarNavDivider :classes="item.class"/>
          </template>
          <template v-else-if="item.label">
            <SidebarNavLabel :name="item.name" :url="item.url" :icon="item.icon" :label="item.label" :classes="item.class"/>
          </template>
          <template v-else>
            <template v-if="item.children">
              <!-- First level dropdown -->
              <SidebarNavDropdown :permission="item.permission" :name="item.name" :url="item.url" :icon="item.icon">
                <template v-for="(childL1, index) in item.children">
                  <template v-if="isItemVisible(childL1)">
                    <template v-if="childL1.children">
                      <!-- Second level dropdown -->
                      <SidebarNavDropdown :permission="childL1.permission || item.permission" :name="childL1.name" :url="childL1.url" :icon="childL1.icon">
                        <template v-for="(childL2, index) in childL1.children">
                          <li class="nav-item" v-if="isItemVisible(childL2)">
                            <SidebarNavLink :name="childL2.name" :permission="childL2.permission || childL1.permission || item.permission" :url="childL2.url" :icon="childL2.icon" :badge="childL2.badge" :variant="item.variant"/>
                          </li>
                        </template>
                      </SidebarNavDropdown>
                    </template>
                    <template v-else>
                      <SidebarNavItem :classes="item.class">
                        <SidebarNavLink :name="childL1.name" :permission="childL1.permission || item.permission" :url="childL1.url" :icon="childL1.icon" :badge="childL1.badge" :variant="item.variant"/>
                      </SidebarNavItem>
                    </template>
                  </template>
                </template>
              </SidebarNavDropdown>
            </template>

            <template v-else>
              <SidebarNavItem :classes="item.class">
                <SidebarNavLink :urlName="item.urlName" :permission="item.permission" :name="item.name" :url="item.url" :icon="item.icon" :badge="item.badge" :variant="item.variant"/>
              </SidebarNavItem>
            </template>
          </template>
        </template>
      </ul>
      <slot></slot>
    </nav>
    <SidebarFooter/>
    <SidebarMinimizer/>
  </div>
</template>
<script>
import SidebarFooter from './SidebarFooter'
import SidebarForm from './SidebarForm'
import SidebarHeader from './SidebarHeader'
import SidebarMinimizer from './SidebarMinimizer'
import SidebarNavDivider from './SidebarNavDivider'
import SidebarNavDropdown from './SidebarNavDropdown'
import SidebarNavLink from './SidebarNavLink'
import SidebarNavTitle from './SidebarNavTitle'
import SidebarNavItem from './SidebarNavItem'
import SidebarNavLabel from './SidebarNavLabel'
import {mapGetters} from 'vuex'

export default {
  name: 'sidebar',
  data () {
    return {
      value: '',
      suggestionAttribute: 'original_title',
      suggestions: [],
      selectedEvent: ''
    }
  },
  props: {
    navItems: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  components: {
    SidebarFooter,
    SidebarForm,
    SidebarHeader,
    SidebarMinimizer,
    SidebarNavDivider,
    SidebarNavDropdown,
    SidebarNavLink,
    SidebarNavTitle,
    SidebarNavItem,
    SidebarNavLabel
  },
  methods: {
    handleClick (e) {
      e.preventDefault()
      e.target.parentElement.classList.toggle('open')
    },
    bytesToSize (bytes) {
      let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
      if (bytes === 0) return '0 Byte'
      let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
      return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i]
    },
    toHHMMSS (secNum) {
      let hours = Math.floor(secNum / 3600)
      let minutes = Math.floor((secNum - (hours * 3600)) / 60)
      let seconds = secNum - (hours * 3600) - (minutes * 60)
      if (hours < 10) { hours = '0' + hours }
      if (minutes < 10) { minutes = '0' + minutes }
      if (seconds < 10) { seconds = '0' + seconds }
      return hours + ':' + minutes + ':' + seconds
    },
    isItemVisible (item) {
      if (item.permission && !this.hasPermission(item.permission)) {
        return false
      }
      if (item.hidePermission && this.hasPermission(item.hidePermission)) {
        return false
      }
      if (item.children) {
        return item.children.some(child => this.isItemVisible(child))
      }
      return true
    }
  },
  computed: {
    ...mapGetters({
      stats: 'serverStats'
    }),
    filteredNavItems () {
      const items = this.navItems.filter((item, index) => {
        if (item.title) {
          for (let i = index + 1; i < this.navItems.length; i++) {
            const nextItem = this.navItems[i]
            if (nextItem.title || nextItem.divider) break
            if (this.isItemVisible(nextItem)) return true
          }
          return false
        }
        if (item.divider) return true
        return this.isItemVisible(item)
      })

      return items.filter((item, index) => {
        if (item.divider) {
          if (index === 0 || index === items.length - 1) return false
          if (items[index + 1].divider) return false
        }
        return true
      })
    }
  }
}
</script>

<style lang="css">
  .nav-link {
    cursor:pointer;
  }
</style>
